import { EMPTY_OBJECT } from '../../../constants/common'
import { Table } from '../../Table'
import { EpostValidationErrorsTableRow } from '../EpostValidationErrorsTableRow'

import { EPOST_VALIDATION_ERRORS_HEADER_COLUMNS } from './EpostValidationErrorsTable.constants'

import * as styles from './EpostValidationErrorsTable.module.css'

function EpostValidationErrorsTable({
  TableRow = EpostValidationErrorsTableRow,
  className = styles.table,
  columns = EPOST_VALIDATION_ERRORS_HEADER_COLUMNS,
  headerRowProps: {
    className: headerRowClassName = styles.row,
    ...headerRowProps
  } = EMPTY_OBJECT,
  items,
  rowProps: {
    className: rowCellClassName = styles.cell,
    ...rowProps
  } = EMPTY_OBJECT,
}) {
  return (
    <Table
      TableRow={TableRow}
      actionsColumnWidth={0}
      className={className}
      columns={columns}
      headerRowProps={{
        ...headerRowProps,
        className: headerRowClassName,
        resizable: false,
        withCellBorder: false,
      }}
      items={items}
      rowProps={{
        ...rowProps,
        cellClassName: rowCellClassName,
      }}
      tableRowClassName={styles.row}
    />
  )
}

export default EpostValidationErrorsTable
